import React, { useState } from 'react';
import { CheckIcon, AlertCircleIcon } from 'lucide-react';
interface BusinessVerificationProps {
  onNext: () => void;
}
const BusinessVerification: React.FC<BusinessVerificationProps> = ({
  onNext
}) => {
  const [abn, setAbn] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [businessDetails, setBusinessDetails] = useState<any>(null);
  const handleVerify = () => {
    setIsVerifying(true);
    // Simulate API call to verify ABN
    setTimeout(() => {
      setIsVerifying(false);
      setIsVerified(true);
      setBusinessDetails({
        name: 'Acme Supplies Pty Ltd',
        abn: '12 345 678 901',
        address: '123 Business St, Sydney NSW 2000',
        status: 'Active'
      });
    }, 1500);
  };
  return <div className="space-y-6" data-id="element-712">
      <div data-id="element-713">
        <h2 className="text-lg font-medium text-gray-900" data-id="element-714">
          Business Verification
        </h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-715">
          We need to verify your business details to ensure secure payments.
        </p>
      </div>
      <div data-id="element-716">
        <label htmlFor="abn" className="block text-sm font-medium text-gray-700" data-id="element-717">
          Australian Business Number (ABN)
        </label>
        <div className="mt-1 flex rounded-md shadow-sm" data-id="element-718">
          <input type="text" name="abn" id="abn" value={abn} onChange={e => setAbn(e.target.value)} disabled={isVerified} className="flex-1 min-w-0 block w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. 12345678901" data-id="element-719" />
          <button type="button" onClick={handleVerify} disabled={abn.length < 9 || isVerifying || isVerified} className={`ml-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${abn.length < 9 || isVerifying || isVerified ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-720">
            {isVerifying ? 'Verifying...' : isVerified ? 'Verified' : 'Verify ABN'}
          </button>
        </div>
      </div>
      {isVerified && businessDetails && <div className="rounded-md bg-green-50 p-4" data-id="element-721">
          <div className="flex" data-id="element-722">
            <div className="flex-shrink-0" data-id="element-723">
              <CheckIcon className="h-5 w-5 text-green-400" data-id="element-724" />
            </div>
            <div className="ml-3" data-id="element-725">
              <h3 className="text-sm font-medium text-green-800" data-id="element-726">
                Business verified
              </h3>
              <div className="mt-2 text-sm text-green-700" data-id="element-727">
                <ul className="list-disc pl-5 space-y-1" data-id="element-728">
                  <li data-id="element-729">Business Name: {businessDetails.name}</li>
                  <li data-id="element-730">ABN: {businessDetails.abn}</li>
                  <li data-id="element-731">Address: {businessDetails.address}</li>
                  <li data-id="element-732">Status: {businessDetails.status}</li>
                </ul>
              </div>
              <div className="mt-4" data-id="element-733">
                <div className="-mx-2 -my-1.5 flex" data-id="element-734">
                  <button type="button" className="bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600" onClick={() => {
                setIsVerified(false);
                setBusinessDetails(null);
                setAbn('');
              }} data-id="element-735">
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
      <div className="pt-5" data-id="element-736">
        <div className="flex justify-end" data-id="element-737">
          <button type="button" disabled={!isVerified} onClick={onNext} className={`ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${!isVerified ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-738">
            Next Step
          </button>
        </div>
      </div>
    </div>;
};
export default BusinessVerification;